import { useEffect, useState } from 'react';
import dropdowns from '../utils/unitFilterDropdowns';
import checkboxes from '../utils/unitFilterCheckboxes';
import SwiperContainer from './SwiperContainer.component';

import initFilterState from '../utils/initFilterState';

import Checkmark from '../assets/svg/checkmark.svg';
import Arrow from '../assets/svg/arrow.svg';

const Units = ({ units }) => {  
    const [unitFilters, setUnitFilters] = useState(initFilterState);
    const [activeUnits, setActiveUnits] = useState([]);
    const [forceUpdate, setForceUpdate] = useState(0);

    useEffect(() => {
        filterActiveUnits();
        setActiveUnits(units);
    }, [units]);

    useEffect(() => {
        filterActiveUnits();
    }, [unitFilters]);

    const resetFilters = () => (setUnitFilters(initFilterState));

    const filterActiveUnits = async () => {
        let active = units;

        dropdowns.forEach(dropdown => {
            const { id } = dropdown;

            if (unitFilters[id] !== '*') {
                active = active.filter(unit => {
                    if (unit[id] === unitFilters[id]) return unit;
                })
            }
        });

        checkboxes.forEach(chk => {
            const { id } = chk;
            
            if (unitFilters[id] === true) {
                active = active.filter(unit => {
                    if (unit[id] === unitFilters[id]) return unit;
                })
            }
        })

        setForceUpdate(forceUpdate + 1);
        setActiveUnits(active);
   }

    return (
        <div id="units" className="units">
            <UnitsFilter unitFilters={unitFilters} setUnitFilters={setUnitFilters} resetFilters={resetFilters} />
            <UnitsContent activeUnits={activeUnits} forceUpdate={forceUpdate}  />
        </div>
    )
}

const UnitsFilter = ({ unitFilters, setUnitFilters, resetFilters }) => {
    const renderDropdown = (dropdown, i) => {
        const { values } = dropdown;
        const initValue = unitFilters[dropdown.id] === '*';

        const handleInputChange = (e) => {
            setUnitFilters((prevState) => {
                return {
                    ...prevState,
                    [e.target.name]: e.target.value
                }
            })
        }

        return (
            <div className="units__dropdown">
                <img className="units__dropdown--icon" src={Arrow} alt="Arrow" />
                <select name={dropdown.id} id={dropdown.id} onInput={(e) => handleInputChange(e)} value={unitFilters[dropdown.id]}>
                    <option value="*" disabled={initValue}>{initValue ? dropdown.label : 'Reset Filter'}</option>
                    {values.map((val, i) => <option key={i} value={val}>{val}</option>)}
                </select>
            </div>
        )
    }

    const renderCheckbox = (checkbox, i) => {
        const checked = unitFilters[checkbox.id];
        const classes = ['units__checkbox'];
        checked && classes.push('active');

        const handleInputChange = (e) => {
            setUnitFilters((prevState) => {
                return {
                    ...prevState,
                    [e.target.name]: e.target.checked
                }
            })
        }

        return  (
            <div className={classes.join(' ')}>
                <input type="checkbox" name={checkbox.id} defaultChecked={checked} onInput={(e) => handleInputChange(e)} />
                <img className="units__checkbox--icon" src={Checkmark} alt="Check" />
                <span>{checkbox.label}</span>
            </div>
        )
    }

    return (
        <div className="units__filter">
            <div className="units__dropdowns">
                {dropdowns.map((dropdown, i) => renderDropdown(dropdown, i))}
            </div>

            <div className="units__checkboxes">
                {checkboxes.map((checkbox, i) => renderCheckbox(checkbox, i))}
            </div>

            <div className="units__reset">
                <div className="btn" onClick={() => resetFilters()}>Reset</div>
            </div>
        </div>
    )
}

const UnitsContent = ({ activeUnits, forceUpdate }) => {
    return (
        <div className="units__content">
            <SwiperContainer units={activeUnits} forceUpdate={forceUpdate} />
        </div>
    )
}



export default Units;